import { Header } from "@/components/landing/Header";
import { HeroSection } from "@/components/landing/HeroSection";
import { PartnerStrip } from "@/components/landing/PartnerStrip";
import { AwardsSection } from "@/components/landing/AwardsSection";
import { BentoGrid } from "@/components/landing/BentoGrid";
import { ProductsSection } from "@/components/landing/ProductsSection";
import { ConfiguratorTeaser } from "@/components/landing/ConfiguratorTeaser";
import { ServicesSection } from "@/components/landing/ServicesSection";
import { Footer } from "@/components/landing/Footer";
import { useLanguage } from "@/i18n/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

const productJsonLd = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Hoooly",
  description:
    "Smart bin AI per smistamento automatico rifiuti con purezza del 95%. Genera KPI audit-ready per compliance CSRD, reporting ESG Scope 3, riduzione Plastic Tax e ottimizzazione TARI.",
  brand: { "@type": "Brand", name: "Ganiga" },
  manufacturer: {
    "@type": "Organization",
    name: "GANIGA INNOVATION S.R.L.",
    url: "https://ganiga.ai",
  },
  category: [
    "Waste Management",
    "CSRD Compliance",
    "ESG Technology",
    "Circular Economy",
    "Smart Waste Solutions",
  ],
  additionalProperty: [
    { "@type": "PropertyValue", name: "Technology", value: "Computer Vision AI" },
    { "@type": "PropertyValue", name: "Sorting Purity", value: "95%" },
    { "@type": "PropertyValue", name: "Compliance", value: "CSRD, EU Taxonomy, EPR, Plastic Tax" },
    { "@type": "PropertyValue", name: "Output", value: "KPI audit-ready, ESG Scope 3 data" },
  ],
  offers: {
    "@type": "Offer",
    availability: "https://schema.org/InStock",
    url: "https://ganiga.ai/it/configurator",
  },
};

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Come Hoooly aiuta la compliance CSRD?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Hoooly genera automaticamente dati certificati sui rifiuti con purezza del 95%, producendo KPI audit-ready per il reporting CSRD. Traccia le emissioni Scope 3 legate ai rifiuti e fornisce documentazione pronta per gli auditor.",
      },
    },
    {
      "@type": "Question",
      name: "Hoooly puo ridurre la Plastic Tax e la TARI?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Si, migliorando la qualita della raccolta differenziata fino al 95% di purezza, Hoooly riduce i costi TARI grazie a tariffe agevolate per chi differenzia meglio, e minimizza l'esposizione alla Plastic Tax attraverso il corretto smistamento degli imballaggi.",
      },
    },
    {
      "@type": "Question",
      name: "In che modo Hoooly migliora il rating ESG e l'accesso ai Green Loans?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Hoooly fornisce dati ambientali certificati e misurabili che migliorano il rating ESG aziendale. Un rating ESG piu alto facilita l'accesso a Green Loans, finanziamenti agevolati e condizioni bancarie piu favorevoli secondo i criteri EU Taxonomy.",
      },
    },
    {
      "@type": "Question",
      name: "Cos'e la EU Taxonomy e come Hoooly supporta la conformita?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "La EU Taxonomy e il framework europeo che classifica le attivita economiche sostenibili. Hoooly supporta la conformita fornendo dati oggettivi e tracciabili sulla gestione dei rifiuti, un criterio chiave per dimostrare l'allineamento alle attivita considerate sostenibili.",
      },
    },
  ],
};

const homeJsonLd = [productJsonLd, faqJsonLd];

const Index = () => {
  const { language } = useLanguage();
  const isIt = language === "it";

  usePageMeta({
    title: isIt
      ? "Ganiga | AI Smart Bin per Compliance CSRD, ESG e Riduzione TARI"
      : "Ganiga | AI Smart Bins for CSRD Compliance, ESG Data and Waste Costs",
    description: isIt
      ? "Hoooly: cestini AI con purezza del 95% per dati ESG audit-ready. Conformita CSRD, riduzione Plastic Tax, ottimizzazione TARI e accesso a Green Loans."
      : "Hoooly: AI smart bins with 95% sorting purity for audit-ready ESG data. CSRD compliance, Plastic Tax reduction, lower waste costs and access to Green Loans.",
    path: `/${language}`,
    jsonLd: homeJsonLd,
  });

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <PartnerStrip />
        <ProductsSection />
        <BentoGrid />
        <ConfiguratorTeaser />
        <ServicesSection />
        <AwardsSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
